import { CHERRY_DEV } from '../CherrySoftware/cherryDevBrand';

export { CHERRY_DEV };

const BRAND_NAME = 'cherryDev';

export const WHATSAPP_PHONE =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_CHERRY_SOFTWARE_WHATSAPP_PHONE) ||
  '';

export const WHATSAPP_DEFAULT =
  `Hola ${BRAND_NAME}, quiero solicitar una cotización gratis para una web o tienda online.`;

export const buildPackageWhatsAppMessage = (planName) =>
  `Hola ${BRAND_NAME}, quiero elegir el ${planName}. ¿Me envían la propuesta y los siguientes pasos?`;

export const PAGE_TITLE = `${BRAND_NAME} | Web y Tienda Online en 7 días`;
export const PAGE_DESCRIPTION =
  'Convierte visitas en clientes con una web o tienda online profesional en menos de 7 días. Dominio y hosting gratis el primer año. Cotización por WhatsApp.';

export const hero = {
  brand: BRAND_NAME,
  title: 'Convierte tus visitas en clientes con una Web o Tienda Online profesional en menos de 7 días.',
  subtitle:
    'Deja de depender solo de las redes sociales. Diseñamos plataformas rápidas, autogestionables y optimizadas para vender en automático desde el primer día.',
  cta: 'Solicitar Cotización Gratis por WhatsApp',
  microCopy: 'Respuesta inmediata · Entrega garantizada en 7 días · Pagas el 50% al iniciar',
  highlights: ['Lista en 7 días', 'Autogestionable', 'Dominio + Hosting 1 año'],
};

export const pain = {
  overline: 'Diagnóstico',
  title: '¿Tu negocio sigue perdiendo ventas por no tener un sitio web profesional?',
  items: [
    {
      id: 'chat',
      title: 'Ventas por chat agotadoras',
      text:
        'Te pasas el día respondiendo “precio por privado” y enviando números de cuenta manualmente.',
      icon: 'voice',
      color: 'primary',
    },
    {
      id: 'confianza',
      title: 'Poca confianza',
      text:
        'Los clientes dudan de comprarte porque no ven un sitio estructurado ni un proceso de pago seguro.',
      icon: 'lockOpen',
      color: 'secondary',
    },
    {
      id: 'inventario',
      title: 'Sin control de inventario',
      text:
        'Te cuesta organizar productos, pedidos y catálogo en un solo lugar.',
      icon: 'dashboard',
      color: 'primary',
    },
  ],
  solution:
    'Te entregamos una herramienta de ventas lista para usar, donde tus clientes ven tu catálogo, compran o te contactan en solo 2 clics.',
};

export const packages = {
  overline: 'Oferta e inversión',
  title: 'Elige el plan que tu emprendimiento necesita',
  subtitle:
    'Desde $80 con dominio, hosting y landing lista. Precios transparentes, sin sorpresas.',
  plans: [
    {
      id: 'landing',
      name: 'Landing Express',
      tag: 'Promo de entrada',
      focus:
        'Ideal para empezar ya: dominio .com, hospedaje y landing profesional de una página, adaptada a tu negocio.',
      price: 80,
      priceNote: 'pago único · dominio + hosting por 1 año',
      delivery: '3 a 5 días',
      featured: true,
      badge: 'Compite desde $80',
      cta: 'Elegir Landing Express',
      rows: [
        {
          label: 'Incluye',
          value: 'Dominio .com + hospedaje por 1 año + configuración y diseño',
        },
        {
          label: 'Plataforma',
          value: 'Landing a medida, rápida y optimizada (sin WordPress)',
        },
        {
          label: '5 secciones',
          value:
            'Slide de servicios/productos, Quiénes somos, Servicios o Productos, Formulario de contacto, Ubicación y redes',
        },
        {
          label: 'Extras',
          value: 'Diseño mobile, SSL y botón de WhatsApp',
        },
      ],
    },
    {
      id: 'web',
      name: 'Paquete Web',
      tag: 'Servicios / Marca personal',
      focus: 'Marcas personales, profesionales y servicios con más secciones y captura de leads',
      price: 299,
      priceNote: 'ó 2 pagos de $150',
      delivery: '5 a 7 días',
      featured: false,
      badge: null,
      cta: 'Elegir Plan Web',
      rows: [
        { label: 'Estructura', value: 'Hasta 5 secciones (Inicio, Nosotros, Servicios, Galería, Contacto)' },
        { label: 'Integraciones', value: 'Botón directo a WhatsApp + Formulario de captura' },
        { label: 'Autogestionable', value: 'Sí — subes fotos y textos tú mismo' },
        { label: 'Dominio y Hosting', value: 'Gratis por 1 año' },
      ],
    },
    {
      id: 'ecommerce',
      name: 'Paquete E-Commerce Pro',
      tag: 'Tienda online',
      focus: 'Tiendas de ropa, productos físicos y catálogos',
      price: 499,
      priceNote: 'ó 2 pagos de $250',
      delivery: '7 a 10 días',
      featured: false,
      badge: 'Para vender online',
      cta: 'Elegir Plan E-Commerce',
      rows: [
        { label: 'Estructura', value: 'Catálogo ilimitado + Carrito + Catálogo interactivo' },
        { label: 'Integraciones', value: 'Pasarelas de pago + Cotizador / WhatsApp' },
        { label: 'Autogestionable', value: 'Sí — gestión fácil de inventario y pedidos' },
        { label: 'Dominio y Hosting', value: 'Gratis por 1 año' },
      ],
    },
  ],
};

export const benefits = {
  overline: 'Lo que incluye',
  title: 'Lo que realmente busca el emprendedor',
  items: [
    {
      id: 'cero',
      title: 'Cero complicaciones técnicas',
      text:
        'Nosotros nos encargamos del dominio, hosting, certificados de seguridad (SSL) y configuración.',
      icon: 'build',
    },
    {
      id: 'mobile',
      title: '100% adaptada a celulares',
      text:
        'Mobile First: el 90% de tus clientes comprarán o te contactarán desde el teléfono.',
      icon: 'devices',
    },
    {
      id: 'cap',
      title: 'Capacitación incluida',
      text:
        'Video tutorial corto para que cambies fotos, precios y productos sin pagarle a un programador cada vez.',
      icon: 'assignment',
    },
  ],
};

export const workProcess = {
  overline: 'Proceso',
  title: 'En 3 pasos sencillos',
  subtitle: 'Tú enfócate en tu negocio. Nosotros entregamos la plataforma.',
  steps: [
    {
      phase: '01',
      title: 'Entrevista y Brief',
      subtitle: '15 min para definir el estilo de tu marca, catálogo y requerimientos.',
      icon: 'voice',
    },
    {
      phase: '02',
      title: 'Desarrollo y Diseño',
      subtitle: '5 a 7 días construyendo tu plataforma mientras tú vendes.',
      icon: 'design',
    },
    {
      phase: '03',
      title: 'Lanzamiento y Capacitación',
      subtitle: 'Revisamos detalles, publicamos y te enseñamos a gestionarla.',
      icon: 'launch',
    },
  ],
};

export const faq = {
  overline: 'Garantía y FAQ',
  title: 'Respuestas claras a tus dudas',
  items: [
    {
      question: '¿Tengo que saber de programación para usarla?',
      answer: 'No. Te la entregamos totalmente lista y fácil de usar.',
      icon: 'code',
    },
    {
      question: '¿Qué pasa si no tengo fotos profesionales?',
      answer:
        'Te asesoramos sobre cómo organizarlas e incluimos imágenes de stock en alta resolución si es necesario.',
      icon: 'design',
    },
    {
      question: '¿Cómo son los pagos?',
      answer:
        '50% al iniciar el proyecto y el 50% restante al entregarte la web 100% terminada.',
      icon: 'money',
    },
  ],
};

export const finalCta = {
  overline: 'Siguiente paso',
  title: 'Agenda tu asesoría express o pide cotización por WhatsApp',
  subtitle:
    'Respuesta inmediata. Te ayudamos a elegir entre Web o E-Commerce según tu negocio.',
  bullets: [
    'Cotización gratis sin compromiso',
    'Entrega en 5 a 10 días según el plan',
    'Pagas solo el 50% al iniciar',
  ],
  cta: 'Escribir por WhatsApp ahora',
  copyright: `© ${new Date().getFullYear()} ${BRAND_NAME}. Webs y tiendas online para emprendedores.`,
};
